import React from 'react';
import { Box, Typography } from '@mui/material';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';
import { buildFunnel } from './widgetData';

const FunnelWidget = ({ widget, rows }) => {
  const { title, stageField, valueField, stages } = widget.params || {};
  const funnel = buildFunnel({ rows, stageField, valueField, stages });

  if (!funnel.length) {
    return (
      <WidgetCard
        title={title || 'Funnel'}
        subtitle={stageField}
        testId={`report-widget-${widget.id || widget.type}`}
      >
        <WidgetEmptyState message="Funnel data is not available yet." />
      </WidgetCard>
    );
  }

  const maxValue = Math.max(...funnel.map((entry) => entry.value || 0), 1);

  return (
    <WidgetCard
      title={title || 'Funnel'}
      subtitle={stageField}
      testId={`report-widget-${widget.id || widget.type}`}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {funnel.map((entry) => (
          <Box key={entry.stage} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              sx={{
                height: 18,
                width: `${(entry.value / maxValue) * 100}%`,
                minWidth: 20,
                backgroundColor: 'primary.main',
                borderRadius: 1,
              }}
            />
            <Typography variant="caption">
              {entry.stage}: {entry.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </WidgetCard>
  );
};

export default FunnelWidget;
